import { render, staticRenderFns } from "./ProjectRepRemarks.vue?vue&type=template&id=036db18a&scoped=true&"
import script from "./ProjectRepRemarks.vue?vue&type=script&lang=js&"
export * from "./ProjectRepRemarks.vue?vue&type=script&lang=js&"
import style0 from "./ProjectRepRemarks.vue?vue&type=style&index=0&id=036db18a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036db18a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('036db18a')) {
      api.createRecord('036db18a', component.options)
    } else {
      api.reload('036db18a', component.options)
    }
    module.hot.accept("./ProjectRepRemarks.vue?vue&type=template&id=036db18a&scoped=true&", function () {
      api.rerender('036db18a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/projects/ProjectRepRemarks.vue"
export default component.exports